import Vue from "vue";
// @ts-ignore
import VueSignaturePad from "vue-signature-pad";
Vue.use(VueSignaturePad);
